<template>
  <div class="w-100">
    <div id="footer">
      <div class="w-100">
        <b-row>
          <b-col class="text-center position-relative" style="padding: 40px 0 30px;">
            <b-row class="m-auto yahei" style="width: fit-content;">
              <b-col class="p-0">
                <b-img :src="require('../assets/icon-iso9001.png')"></b-img>
                <div class="fs-16 yahei text-white" style="margin-top: 30px;">ISO 9001认证</div>
              </b-col>
              <b-col class="gxqy p-0" style="margin: 0 120px;">
                <b-img :src="require('../assets/icon-gxqy.png')"></b-img>
                <div class="fs-16 yahei text-white" style="margin-top: 30px;">国家高新技术企业</div>
              </b-col>
              <b-col class="p-0">
                <b-img :src="require('../assets/icon-iso14001.png')"></b-img>
                <div class="fs-16 yahei text-white" style="margin-top: 30px;">ISO 14001认证</div>
              </b-col>
            </b-row>
            <div class="w-100 position-absolute" style="left: 0;bottom: -1px;border-bottom: 1px solid #ffffff1a;"></div>
          </b-col>
        </b-row>
        <b-row class="main-content">
          <div class="w-100" style="border-bottom: 2px solid #ffffff4d"></div>
        </b-row>
        <b-row class="link-row main-content yahei">
          <b-col class="col-4 col-md-2 pl-0 text-left" style="max-width: 120px;">
            <ul>
              <li class="ul-title">解决方案</li>
              <li><router-link to="/solution#ac1">方案介绍</router-link></li>
              <li><router-link to="/solution#ac2">方案优势</router-link></li>
              <li><router-link to="/solution#ac3">方案价值</router-link></li>
              <li><router-link to="/custom-case">客户案例</router-link></li>
            </ul>
          </b-col>
          <b-col class="col-4 col-md-2 pr-0">
            <ul class="w-100 vline" style="padding-left: 20%;">
              <li class="ul-title">产品中心</li>
              <li><router-link to="/product-1">道路泊位智能翻板</router-link></li>
              <li><router-link to="/product-2">物联网平台</router-link></li>
            </ul>
          </b-col>
          <b-col class="col-4 col-md-2">
            <ul class="w-100" style="padding-left: 20%;">
              <li class="ul-title">合作伙伴计划</li>  
              <li><router-link to="/partner#ac1">合作伙伴计划</router-link></li>
              <li><router-link to="/partner#ac2">申请流程</router-link></li>
              <li><router-link to="/partner#ac3">更多动态</router-link></li>
            </ul>
          </b-col>

          <b-col class="col-4 col-md-2 pr-0" align="center">
            <ul class="pr-0 vline">
              <li class="ul-title">关于我们</li>
              <li><router-link to="/about#ac1">公司介绍</router-link></li>
              <li><router-link to="/about#ac2">发展历程 </router-link></li>
              <li><router-link to="/about#ac3">企业文化 </router-link></li>
              <!-- <li><router-link to="/about#ac4">公司环境 </router-link></li> -->
            </ul> 
          </b-col>
          <b-col class="col-8 col-md-4 pr-0" align="left">
            <ul class="pr-0" style="padding-left: 30px;">
              <li class="ul-title">关注我们</li>
              <b-row>
                <b-col class="d-inline-flex fs-14" style="color: #999;">
                  <div>
                    <b-img :src="require('../assets/qr_gzh.png')"></b-img>
                    <div class="mt-2 text-center">微信公众号</div>
                  </div>
                  <div class="qrcode" style="margin: 0 30px;">
                    <b-img :src="require('../assets/qr_sph.png')"></b-img>
                    <div class="mt-2 text-center">微信视频号</div>
                  </div>
                  <div>
                    <b-img :src="require('../assets/qr_slwb.png')"></b-img>
                    <div class="mt-2 text-center">新浪微博</div>
                  </div>
                </b-col>
              </b-row>
            </ul>
          </b-col>
        </b-row>
        <b-row class="fs-14 position-relative main-content c999" style="font-weight: bold;">
          <div class="w-100 m-auto" style="border-bottom: 1px solid #ffffff1a;"></div>
          <div class="lxwm-title fs-16 text-white yahei text-center">联系我们</div>
          <b-row class="w-100 lxwm font-weight-normal m-auto" style="padding: 30px 0;">
            <b-col cols="4" class="col-12 col-md-4 text-left" style="min-width: 320px;">地址：苏州工业园区月亮湾路15号中新大厦45楼</b-col>
            <b-col class="col-12 col-md text-center">电话：<a href="tel:051267289416" class="call">0512-67289416</a></b-col>
            <b-col class="col-12 col-md text-center">传真：0512-67289417</b-col>
            <b-col class="col-12 col-md text-right">Email：third@ruolin-link.com</b-col>
          </b-row>
        </b-row>
        <b-row class="main-content c999">
          <div class="w-100" style="border-bottom: 1px solid #ffffff1a"></div>
        </b-row>
        <b-row class="fs-14 yahei">
          <div class="w-100 footer-end">
            Copyright ©江苏若临物联科技有限公司<span class="ml-3 mr-3">版权所有</span>
            <a href="http://beian.miit.gov.cn">苏ICP备18007560号-1</a>
            <span class="ml-3 mr-3">|</span>隐私政策
          </div>
          <div class="w-100 phone-footer-end">
            Copyright ©江苏若临物联科技有限公司<br>版权所有 <a href="http://beian.miit.gov.cn">苏ICP备18007560号-1</a>
            <div style="margin-top: 13px">隐私政策</div>
          </div>
        </b-row>  
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data (){
      return{

      }
    }
  }
</script>

<style scoped>
  a, .call{
      color: #9B9B9B;
  }
  ul{
      list-style: none;
      margin-top: 40px;
      padding-left: 0;
      padding-right: 10px;
  }
  li{
      color: #9B9B9B;
      font-size: 14px;
      margin: 7px 0;
  }
  .vline {
    position: relative;
  }
  .vline::before, .vline::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 120px;
    background: #FFFFFF1A;
  }
  .vline::after {
    right: 0;
    left: unset;
  }
  .ul-title{
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom: 20px;
    font-family: 'PingFang-SC-Bold';
  }
  .lxwm-title {
    position: absolute;
    left: calc(50% - 40px);
    top: -13px;
    width: 80px;
    letter-spacing: 2px;
    background: #25272E;
    font-weight: normal;
  }
  .app-download,.phone-gzh,.phone-footer-end{
      display: none;
  }
  .download-btn{
      border: 1px solid #9B9B9B;
      border-radius: 4px;
      font-size: 13px;
      line-height: 40px;
      text-align: center;
      width: 226px;
      margin: auto;
      position: relative;
      z-index: 200;
  }
  .download-btn img{
      width: 9%;
  }
  .footer-end{
      color: #9B9B9B;
      text-align: center;
      margin-top: 25px;
      margin-bottom: 50px;
  }
  
  /* @media (min-width: 1200px) and (max-width: 1599px) {
    .gzh{
        padding-right: 0;
    }
    .gzh ul{
        padding-right: 0;
    }
  } */
  @media only screen and (max-width:1180px) {
    .link-row {
      padding: 0 10px !important;
    }
  }
  @media only screen and (max-width:900px) {
   .link-row ul {
     padding-left: 0px !important;
   }
   .link-row div:nth-child(2) ul {
     padding-left: 15px !important;
   }
   .qrcode {
     margin: 0 10px !important;
   }
  }
  @media only screen and (min-width:800px) {
    #footer{
        min-height: 350px;
        overflow: hidden;
        white-space:nowrap;
        background: #25272E;
    }
  }

  @media only screen and (max-width:800px) {
    #footer{
        height: calc(100vh - 80px);
        overflow: hidden;
        white-space:nowrap;
        background: #25272E;
    }
    .ul-title{
        font-size: 14px !important;
        color: #FFFFFF !important;
        margin-bottom: 15px !important;
        margin-top: 30px !important;
    }
    .phone,.footer-end{
        display: none;
    }
    .app-download,.phone-gzh,.phone-footer-end{
        display: block;
        text-align: center;
    }
    .phone-footer-end{
        margin-top: 20px;
        color: #9B9B9B;
    }
    /* .about-us{
        text-align: center;
        -webkit-box-flex: 0;
        flex: 0 0 100%;
        max-width: 100%;
        font-size: 12px;
    }
    .about-us ul{
        padding: 0;
        margin: 0;
    }
    .about-us ul li,.phone-footer-end {
        font-size: 12px;
    } */
  }

  @media only screen and (max-width:768px) {
    .lxwm > div{
      text-align: center !important;
    }
    .gxqy {
      margin: auto !important;
      padding: 0 50px !important;
    }
    .fs-16 {
      font-size: 14px;
    }
    .pr-2 {
      padding-right: 0px !important;
    }
    .link-row > div:not(:last-of-type) {
      text-align: center !important;
      padding: 0 !important;
    }
    .link-row > div:nth-child(1), .link-row > div:nth-last-child(1) {
      max-width: 100% !important;
      min-width: 100px;
    }
    .link-row > div:nth-child(2)  ul, .link-row > div:nth-child(3) ul, .link-row > div:nth-child(4) ul {
      padding: 0 5px !important;
    }
    .link-row > div:nth-child(4) .vline::before {
      background: transparent;
    }
    .link-row > div:last-of-type ul {
      padding-left: 25px !important;
    }
    .qrcode {
      margin: 0 25px !important;
    }
    #footer {
      min-height: 835px;
    }
  }

  @media only screen and (max-width:500px) {
    .link-row > div:last-of-type ul {
      padding-left: 10px !important;
    }
  }

  @media only screen and (max-width:450px) {
    .gxqy {
      padding: 0 20px !important;
    }
    .qrcode {
      margin: 0 10px !important;
    }
  }
</style>